import styled from 'styled-components';

export const ModalContent = styled.div`
  padding: 5px;
  text-align: center;
`;

export const IconContainer = styled.div`
  margin-bottom: 16px;
`;

export const SymbolText = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #000000 !important;
`;

export const MessageText = styled.p`
  margin-bottom: 40px;
  font-size: 16px;
  color: #000000 !important;
  line-height: 1.6;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`;
